import { render, staticRenderFns } from "./CompanyTransportTypes.vue?vue&type=template&id=372a4d3a&scoped=true&"
import script from "./CompanyTransportTypes.vue?vue&type=script&lang=js&"
export * from "./CompanyTransportTypes.vue?vue&type=script&lang=js&"
import style0 from "./CompanyTransportTypes.vue?vue&type=style&index=0&id=372a4d3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372a4d3a",
  null
  
)

export default component.exports